import { StatusCodes } from "http-status-codes"
import { useCallback, useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../../services/api"
import type { DiMaDetailsHeaderProps } from "../../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../../components/DiMaProgress"
import { DetailsHeaderTab } from "../../../../../components/Helpers"
import { UserContext } from "../../../../../context/UserContext"
import { ApplicationRolePermissionDetailGet } from "../../../../../models/ApplicationRolePermission"
import { useHashTab } from "../../../../../../hooks/useHashTab"
import { ApplicationRolePermissionDetails } from "./details_tab/ApplicationRolePermissionDetails"
import { ApplicationRolePermissionProperties } from "./properties_tab/ApplicationRolePermissionProperties"

export function ApplicationRolePermissionContainer() {
  const { applicationId, roleId, permissionId } = useParams()
  const { user, isLoadingUser } = useContext(UserContext)
  const navigate = useNavigate()

  const { activeTab, handleTabChange: handleChange } = useHashTab("details")

  const [applicationRolePermission, setApplicationRolePermission] =
    useState<ApplicationRolePermissionDetailGet>()
  const [reloadEntity, setReloadEntity] = useState<boolean>(true)

  const returnURL = `/applications/${applicationId}/roles/${roleId}#permissions`

  const reloadApplicationRolePermission = useCallback(
    () => setReloadEntity(true),
    [],
  )

  useEffect(() => {
    if (applicationId && roleId && permissionId && reloadEntity === true) {
      digitalManagerApi
        .get<ApplicationRolePermissionDetailGet>(
          `/applications/${applicationId}/roles/${roleId}/permissions/${permissionId}`
        )
        .then((res) => {
          if (res.status === StatusCodes.OK) {
            setApplicationRolePermission(res.data)
            setReloadEntity(false)
          }
        })
        .catch((err) => {
          if (err.response.status) {
            navigate(returnURL)
          }
        })
    }
  }, [applicationId, navigate, permissionId, reloadEntity, returnURL, roleId])

  if (!applicationId || !roleId || !permissionId) {
    return <Navigate to="/applications" />
  }

  if (!applicationRolePermission || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: applicationRolePermission.permission.name,
    label: "Permission ID",
    subtitle: applicationRolePermission.permission.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DetailsHeaderTab
        detailsHeaderProps={detailsHeaderProps}
        tabItems={[
          { id: "details", label: "Details" },
          { id: "properties", label: "Properties" },
        ]}
        activeTab={activeTab}
        onTabChange={handleChange}
      />

      {activeTab === "details" && (
        <ApplicationRolePermissionDetails
          applicationRolePermission={applicationRolePermission}
          user={user}
        />
      )}

      {activeTab === "properties" && (
        <ApplicationRolePermissionProperties
          applicationRolePermission={applicationRolePermission}
          reloadApplicationRolePermission={reloadApplicationRolePermission}
          user={user}
        />
      )}
    </div>
  )
}
